import React from "react";

const ChildBirthContent = {
  checklistText: (
    <React.Fragment>
      <p>
        Childbirth cash benefit is not available on all plans. Please check your
        handbook to see if you have cover.
      </p>
      <p>
        We'll pay for each birth occurring after one of the parents named on the
        birth certificate has been covered by this plan for 10 consecutive
        months or more.
      </p>
      <p>Before you start, please have the following ready:</p>
    </React.Fragment>
  ),
  checklist: [
    "Invoices, receipts or bills for your claim",
    "A copy of your child's birth certificate"
  ],
  checklistSLA:
    "Once you've submitted your documents, please allow up to 10 working days for us to review them.",
  infoBoxIconClass: "icon-help-outline"
};

const ChildBirth = {
  HOL: {
    ...ChildBirthContent,
    checklistText: (
      <React.Fragment>
        <p>
          Childbirth cash benefit is not available on all policies. Please check
          your handbook to see if you have cover.
        </p>
        <p>
          We'll pay for each birth occurring after one of the parents named on
          the birth certificate has been covered by this policy for 10
          consecutive months or more.
        </p>
        <p>Before you start, please have the following ready:</p>
      </React.Fragment>
    )
  },
  Any: ChildBirthContent
};

export default ChildBirth;
